import "./App.css";
import "./styles/primitives.css";
// Buttons, dropdown arrows and focus rings for every page, the same values as
// the seller app. After primitives, before the page sheets that read them.
import "./styles/controls.css";
import "./styles/page-shell.css";
// Record popup blocks and the detail bodies, global so every popup is styled
// whichever page opens it.
import "./styles/record-popup.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-medium-image-zoom/dist/styles.css";
import "./styles/swalTheme.css";
import "./styles/toast.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import Routing from "./components/Routing/Routing";
import { queryClient } from "./queryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* NotificationsProvider lives in AppLayout, not here: mounted before
          sign in, it found no token, never started polling, and stayed that
          way until a full reload. AppLayout mounts after sign in. */}
      {/* Opaque rather than glass: a toast lands over arbitrary content, so
          a translucent surface would sit on whatever happened to be under
          it. Tokens are read from :root, which App.css defines. */}
      <Toaster
        position="top-center"
        // react-hot-toast defaults its container to z-index 9999 — the exact
        // value PopUpContainer's overlay uses. On a tie the later element in
        // the DOM wins, and <Routing /> renders after this, so every toast
        // raised from inside a modal (save confirmations, validation errors,
        // "copied to clipboard") was painted behind it and never seen.
        // 20001 clears both the modal and SweetAlert's 20000.
        containerStyle={{ zIndex: 20001 }}
        // className, NOT style: the library applies `style` inline, which
        // beats every class selector and made the toast unstylable from CSS.
        // The look lives in styles/toast.css, byte-identical to the seller
        // app's copy.
        toastOptions={{
          duration: 4000,
          className: "app-toast",
          success: {
            className: "app-toast is-success",
            iconTheme: { primary: "#22c55e", secondary: "#ffffff" },
          },
          error: {
            className: "app-toast is-error",
            iconTheme: { primary: "#ef4444", secondary: "#ffffff" },
          },
        }}
      />
      <Routing />
    </QueryClientProvider>
  );
}

export default App;
// app
